import '../styles/App.scss';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import React from 'react';
import { AuthProvider, UserProvider } from '../contexts/providers';
import { BrowserRouter } from 'react-router-dom';
import HomeBase from './HomeBase';
import { ClientSettingsProvider } from '../contexts/client-settings';
import { SideNavSelectionProvider } from '../contexts/sidenavselection';

export default function App() {
	return (
		<>
			<UserProvider>
				<ClientSettingsProvider>
					<AuthProvider>
						<BrowserRouter>
							<SideNavSelectionProvider>
								<HomeBase />
							</SideNavSelectionProvider>
						</BrowserRouter>
					</AuthProvider>
				</ClientSettingsProvider>
			</UserProvider>
		</>
	);
}
